import styled from 'styled-components';

export const ActionTextWrap = styled.span`
  display: flex;
  .icon-arrow {
    width: 0.781vw;
    path {
      fill: ${(props) => (props.selected ? 'white' : '#415364')};
    }
  }

  @media only screen and (max-width: 1100px) {
    .icon-arrow {
      font-size: 2.5vw;
      width: 1.781vw;
      margin-left: 1vw;
    }
  }
`;

export const IconWrap = styled.div`
  height: 3.646vw;
  min-width: 3.646vw;
  width: 3.646vw;
  margin-right: 1.563vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 0 36.8px 3.2px rgba(0, 0, 0, 0.08);
  padding: 0.781vw;
  background-color: ${(props) => props.selected && 'white'};
  box-shadow: ${(props) => props.selected && 'none'};
  box-sizing: border-box;
  height: auto;

  .demo-icon {
    width: 100%;
    path {
      fill: #54bee6;
      fill: ${(props) => (props.selected ? '#0071ce' : '#54bee6')};
    }
  }

  @media only screen and (max-width: 1100px) {
    width: 14.5vw;
    background-color: transparent;
    box-shadow: none;
  }
`;

export const SectionText = styled.div`
  color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DemoText = styled.span`
  color: #415364;
  font-family: 'Poppins';
  font-size: 0.833vw;
  margin-right: 0.417vw;
  color: ${(props) => props.selected && 'white'};
  max-width: 80%;
  @media only screen and (max-width: 1100px) {
    font-size: 2.5vw;
  }
`;

export const StyledMenuItem = styled.div`
  width: 15.833vw;
  border-radius: 16px;
  border: solid 0 #e5e7eb;
  margin-bottom: 1.563vw;
  padding: 0.26vw;
  display: flex;
  background-color: ${(props) => props.selected && '#0071ce'};
  box-shadow: ${(props) => props.selected && 'none'};
  &:hover {
    background-color: white;
    box-shadow: 0 0 36.8px 3.2px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }

  &:hover ${ActionTextWrap} {
    .icon-arrow {
      path {
        fill: #0071cc;
      }
    }
  }

  &:hover ${IconWrap} {
    background-color: #005daa;
    box-shadow: none;
    height: auto;

    path {
      fill: white;
    }

    .demo-icon path {
      fill: white;
    }
  }

  &:hover ${DemoText} {
    color: #005daa;
    text-decoration: underline;
    font-weight: 600;
  }

  @media only screen and (max-width: 1100px) {
    width: 100%;
    width: -moz-available; /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
    width: fill-available;
    background-color: white;
    box-shadow: 0 0 9.8px 2.2px rgb(0 0 0 / 5%);
    padding: 1vw;
    border-radius: 8px;
    display: flex;
    align-items: center;
    min-height: fit-content;
  }
`;

export default StyledMenuItem;
